/* global define */

define([], () => ({
  UPDATE_SETTING: 'UPDATE_SETTING',

  REQUEST_ACCOUNT: 'REQUEST_ACCOUNT',
  UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
  RECEIVE_ACCOUNT: 'RECEIVE_ACCOUNT',
  ERROR_ACCOUNT: 'ERROR_ACCOUNT',

  REQUEST_USERS: 'REQUEST_USERS',
  RECEIVE_USERS: 'RECEIVE_USERS',
  ERROR_USERS: 'ERROR_USERS',

  REQUEST_EMAIL_SETTINGS: 'REQUEST_EMAIL_SETTINGS',
  RECEIVE_EMAIL_SETTINGS: 'RECEIVE_EMAIL_SETTINGS',
  UPDATE_EMAIL_SETTINGS: 'UPDATE_EMAIL_SETTINGS',
  ERROR_EMAIL_SETTINGS: 'ERROR_EMAIL_SETTINGS',

  UPDATE_SITE_SETTINGS: 'UPDATE_SITE_SETTINGS',
  ERROR_SITE_SETTINGS: 'ERROR_SITE_SETTINGS',

  UPDATE_ACCOUNT_SETTINGS: 'UPDATE_ACCOUNT_SETTINGS',
  ERROR_ACCOUNT_SETTINGS: 'ERROR_ACCOUNT_SETTINGS',

  UPDATE_SITE_USERS: 'UPDATE_SITE_USERS',
  ERROR_SITE_USERS: 'ERROR_SITE_USERS',

  UPDATE_NEW_PASSWORD: 'UPDATE_NEW_PASSWORD',
  RECEIVE_NEW_PASSWORD: 'RECEIVE_NEW_PASSWORD',
  ERROR_NEW_PASSWORD: 'ERROR_NEW_PASSWORD',

  // A universal action called on all requests.
  VALIDATE: 'VALIDATE',
}));

